import { Temporal } from "temporal-polyfill";

export const formatNumber = (value: number, maximumFractionDigits = 3) =>
  value.toLocaleString("en-US", { maximumFractionDigits, minimumFractionDigits: maximumFractionDigits });

export const formatCurrency = (
  value: number,
  maximumFractionDigits = 2,
  options?: { roundingMode?: "ceil" | "floor" },
) =>
  `$${value.toLocaleString("en-US", {
    minimumFractionDigits: maximumFractionDigits,
    maximumFractionDigits: maximumFractionDigits,
    roundingMode: options?.roundingMode ?? "halfExpand",
  })}`;

export const formatPercentage = (value: number, maximumFractionDigits = 1) =>
  `${formatNumber(value, maximumFractionDigits)}%`;

// format: YYYY-MM-DD
export const formatDateString = (date: string) => {
  const instant = Temporal.Instant.from(date);
  return instant.toZonedDateTimeISO("UTC").toPlainDate().toString();
};
